import { ISvg } from '@/types/ISvg';

const FloatingContactIcon = (props: ISvg) => {
  const { width = 32, height = 32, color = 'currentColor', className } = props;

  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        stroke={color}
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.0188 12.2373C12.535 15.2586 16.7394 19.463 19.7606 20.9792L21.8664 18.9694C22.4914 18.3729 23.4806 18.3845 24.0914 18.9953L27.2658 22.1697C27.5915 22.4954 27.7491 22.8984 27.7309 23.3587C27.7126 23.8189 27.5235 24.2082 27.173 24.507L23.3911 27.7316C16.4661 27.8338 4.16106 15.7428 4.2663 8.60679L7.49092 4.82493C7.78976 4.47445 8.17903 4.28536 8.63926 4.26705C9.09954 4.24879 9.50256 4.40641 9.8282 4.73211L13.0026 7.90653C13.6135 8.51737 13.625 9.50661 13.0285 10.1316L11.0188 12.2373ZM17.9561 7.25519C19.6708 7.25519 21.2232 7.95015 22.3469 9.07381C23.4705 10.1974 24.1655 11.7498 24.1655 13.4645C24.1655 13.8162 24.4506 14.1014 24.8023 14.1014C25.154 14.1014 25.4392 13.8162 25.4392 13.4645C25.4392 11.3982 24.6016 9.52741 23.2474 8.17326C21.8932 6.81906 20.0224 5.98149 17.956 5.98149C17.6043 5.98149 17.3192 6.26664 17.3192 6.61834C17.3192 6.97004 17.6044 7.25519 17.9561 7.25519ZM17.9561 10.5827C18.7519 10.5827 19.4724 10.9053 19.9939 11.4268C20.5153 11.9482 20.8379 12.6687 20.8379 13.4646C20.8379 13.8163 21.1231 14.1014 21.4747 14.1014C21.8264 14.1014 22.1116 13.8163 22.1116 13.4646C22.1116 12.3171 21.6464 11.2782 20.8944 10.5262C20.1424 9.77419 19.1035 9.30902 17.9561 9.30902C17.6044 9.30902 17.3192 9.59417 17.3192 9.94587C17.3192 10.2976 17.6044 10.5827 17.9561 10.5827Z"
        fill={color}
      />
    </svg>
  );
};

export default FloatingContactIcon;
